export default "__VITE_ASSET__4a5b32a7__"